
import React, { useEffect, useState   } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import './Rapport.css';

const Rapport = () => {
      const navigate = useNavigate();
    var [examen, setExamen] = useState(null);
    const { id } = useParams(); 

    useEffect(() => {
        const fetchExamen = async () => {
          const token = localStorage.getItem("token");
          try {
            const response = await axios.get(process.env.REACT_APP_EUREKA_PACS_URL+`/api/examen/${id}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            setExamen(response.data);
          
            console.log(response.data);
          } catch (error) {
            console.error("Erreur lors de la récupération des détails :", error);
          }
        };
    
        if (id) {
          fetchExamen();
        }
      }, [id]);

    if (!examen) {
        return <p>Chargement des détails de l'examen...</p>;
    }

    const handleEditToggle = () => {
   
    };

    const openOHIFViewer = (examId) => {
        console.log(id);
        const url = process.env.REACT_APP_VIEWER_URL+`/viewer/${examId}`;
        const windowFeatures = "width=800,height=600,resizable,scrollbars=yes";
        const newWindow = window.open(url, "_blank", windowFeatures);
      console.log(examId);
        if (newWindow) {
          newWindow.focus();
        } else {
          alert("La fenêtre pop-up a été bloquée par votre navigateur.");
        }
      };

  
      
  return (
    
    <div class="report-container">
        <div className="buttons">
               <button onClick={() => navigate('/accueil')}>
               <span role="img" aria-label="acceuil">🏠</span>Retour à l’accueil
              </button>
              
              <button className="btn btn-blue">
                <span role="img" aria-label="Actualiser">🔄</span>Actualiser
              </button>
             <button className="btn btn-yellow">
                <Link to={`/examens/${examen.id}`} >
                  <span role="img" aria-label="Éditer">✏️</span> Éditer le rapport
                </Link>
              </button>

              <button className="btn btn-green" onClick={() => window.print()}>
                <span role="img" aria-label="Générer">🖨️</span> Imprimer
              </button>
        
              <button className="btn btn-purple" onClick={() => openOHIFViewer(examen.dicom[0].study)}>
                <span role="img" aria-label="Visualiser">👁️</span> Visualiser les images
              </button>
            </div>
    <div class="header">
      <img src="/clinique.png" alt="clinique" />
      <h2>CENTRE D’IMAGERIE MÉDICALE EUREKA</h2>
      <p>
        12 Rue des Sciences - 75000 Paris<br />
        Tél : 01 23 45 67 89 - Fax : 01 23 45 67 88<br />
        Email : contact@eureka.fr
      </p>
    </div>

    <h1 class="title">Compte Rendu</h1>
    <div class="info-section">
    <div class="info-box">
        <h4>Examen</h4>
        <p><strong>Libelle :</strong> {examen.nom}</p>
        <p><strong>Date de l'examen :</strong> {new Date(examen.created_at).toLocaleDateString('fr-FR', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                                })  }</p>
      </div>
      <div class="info-box">
        <h4>Informations du Patient</h4>
        <p><strong>Nom :</strong> {examen.patient.personne?.nom}</p>
        <p><strong>Prénom :</strong>  {examen.patient.personne?.prenom || ""}</p>
        <p><strong>Date de naissance :</strong> {new Date(examen.patient.personne?.date_naissance).toLocaleDateString('fr-FR', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                                })  }</p>
      </div>
      <div class="info-box">
        <h4>Informations du Radiologue</h4>
        <p><strong>Nom :</strong> {examen.radiologue?.personne?.nom}</p>
        <p><strong>Prenom :</strong> {examen.radiologue?.personne?.prenom}</p>
      </div>
    </div>

    <section>
      <h3 class="section-title">Indication</h3>
      <p class="section-content">{examen.indication}</p>
    </section>

    <section>
      <h3 class="section-title">Résultat</h3>
      <p class="section-content">{examen.resultat}</p>
    </section>

    <section>
      <h3 class="section-title">Conclusion</h3>
      <p class="section-content">{examen.conclusion}</p>
    </section>

    <div class="footer">
      © 2025 Centre d’Imagerie Médicale Eureka — Tous droits réservés
    </div>
  </div>

  );
};

export default Rapport;
